module.exports = __webpack_public_path__ + "static/media/icon-video-camera.dc3c615a.svg";